//@ts-ignore
import TrieSearch from "trie-search";
import { shipList } from "./db";

export const shipTrie = new TrieSearch("name");
//@ts-ignore
shipTrie.addAll(shipList);

